<template>
  <div
    id="attachment-modal"
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-pdf">
      <div class="modal-content">
        <div class="modal-header">
          <modal-close-button @confirmed="closeModal" />
          <h4 class="modal-title">{{$t("global.importfile")}}</h4>
        </div>
        <div class="modal-body">
          <div class="col-xl-12">
            <div class="form-group text-center">
              <vue-2-dropzone
                id="dropzone"
                ref="dokumenteUpload"
                class="
                  dropzone-white dropzone-small
                  vue-dropzone
                  dropzone
                  dz-clickable
                "
                :options="dropzoneOptions"
                @vdropzone-success="fileUploaded"
              ></vue-2-dropzone>
              <button class="btn btn-primary mt-2" @click="uploadFiles">
                {{ $t("global.upload") }}
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="close">
            {{ $t("global.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modal } from "@/mixins/Modal";

import store from "@/store";
import Api from "@/Api";
import vue2Dropzone from "vue2-dropzone";
import { dropzoneOptionsAttachments } from "@/config/Dropzone";
import ModalCloseButton from "@/components/global/ModalCloseButton.vue";

export default {
  name: "AttachmentUploadModal",
  components: {
    vue2Dropzone,
    ModalCloseButton,
  },
  mixins: [modal],
  store,
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      numPages: 1,
      actualPage: 1,
      dropzoneOptions: dropzoneOptionsAttachments(
        Api.defaults.baseURL,
        this.id,
      ),
    };
  },

  //TEMP workaround start
  computed: {
   dropzonetext(){
      return this.$t("global.clickordragfiletoupload")
    }
  },

  watch:{
    dropzonetext(){
      this.changeMessage()
    }
  },

  methods: {
   changeMessage() {
      const dzMessageElement = document.querySelector('.dz-message');
      if (dzMessageElement) {
        const spanElement = dzMessageElement.querySelector('span');
        if (spanElement) {
          spanElement.textContent = this.$t("global.clickordragfiletoupload");
        }
      }
    },
    //TEMP workaround end
    close() {
      $("#attachment-modal").modal("hide");
    },
    uploadFiles() {
      this.$refs.dokumenteUpload.processQueue();
    },
    fileUploaded() {
      $("#attachment-modal").modal("hide");
      this.$emit("uploaded");
    },
    closeModal() {
      this.shown = false;
      $("#" + this.id).modal("hide");
    },
  },
};
</script>

<style>
</style>
